fragment flexibleAnchor on flexibleSections_anchor_BlockType {
    __typename
    anchorId: plaintext
}
